exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.user-check[data-v-3a3cda64] {\n  background: #f5f6fa;\n  border: 1px solid #e0e2ec;\n}\n.delete-warning[data-v-3a3cda64] {\n  background: #fff5f5;\n  border: 1px solid #f2c2c2;\n  color: #8a1f1f;\n}\n.delete-warning ul li[data-v-3a3cda64] {\n  margin-bottom: 4px;\n}\n.c-red[data-v-3a3cda64] {\n  color: #d0021b;\n}\n", ""]);

// exports
